import React, { useState , useContext, useEffect } from 'react'
import DataFetch from '../../Context/DataFetch';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

export default function TeamInfoStatic({MatchData}) {
    const [HomeJersey , setHomeJersey] = useState([])
    const [Awayersey , setAwayersey] = useState([])
    const {StaticsHome , StaticsAway} = useContext(DataFetch)
    const datam = useContext(DataFetch);



    function addDefaultSrc(ev){
      ev.target.src = '/CountryFlag/world.png'
    }
    useEffect(() => {

    if(datam.data1 !== undefined) {
      if(datam.data1.competitor_Id === MatchData.home_Team_Id ) {
        setHomeJersey(JSON.parse(datam.data1.teamcolor))
        setAwayersey(JSON.parse(datam.data2.teamcolor))
     }
      else{
        setHomeJersey(JSON.parse(datam.data2.teamcolor))
         setAwayersey(JSON.parse(datam.data1.teamcolor))
      }
    }
       
       },[])




  return (
    <div className='TeamsContainerPage'>
    <div className='TeamsHeaderPage'>
        <div className='TeamsHeaderPageText'>{MatchData.groupName}</div>
     </div>
    <div className='headTeamsContainer StaticTeamsInfo'>
    <div className='HomeTeamArea'>
        <div className="container__inner">
          {
            HomeJersey !== null ? 
            <div className="football-kit football-kit--stripes">
            <div style={{background: `repeating-linear-gradient(to right, ${HomeJersey.primary}, ${HomeJersey.primary} 10px, ${HomeJersey.secondary} 10px, ${HomeJersey.secondary} 17.5px) `}} className="football-kit__shirt"></div>
                <div style={{ background: 	`repeating-linear-gradient(to bottom, ${HomeJersey.primary}, ${HomeJersey.primary} 10px, ${HomeJersey.secondary} 10px, ${HomeJersey.secondary} 20px) `}} className="football-kit__stripes football-kit__stripes--left"></div>
                <div style={{background: ` repeating-linear-gradient(to bottom, ${HomeJersey.primary}, ${HomeJersey.primary} 10px, ${HomeJersey.secondary} 10px, ${HomeJersey.secondary} 20px)` }} className="football-kit__stripes football-kit__stripes--right"></div>
           </div>
           :
           <div className="football-kit football-kit--stripes">
           <div  className="football-kit__shirt"></div>
           <div className="football-kit__stripes football-kit__stripes--left"></div>
           <div className="football-kit__stripes football-kit__stripes--right"></div>
  </div>
          }
         
    </div>
    <div className='TeamContainerTextHome'><img alt='' src={`https://cdn-images.nvpark.com/logo/${MatchData.home_Team_Id}.png` }  onError={addDefaultSrc} className='TeamsInfoImage' ></img><div className='TeamContainerTeamName'>{MatchData.home_Team_Name}</div></div>
    {
                 MatchData.homeTeamManager !== null ?
                 <div className='ManagerPosition'>
                   <img src='/manager.png' width={17} height={17}></img>
                   <div className='ManagerText'>{MatchData.homeTeamManager}</div>
                </div>  
                :
                ""
             }
    {/* <div className='GridArea'>
      <div className='wrapper2'>
        <div>1
        </div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
      </div>
  
    </div> */}
</div>
    <div className='TeamsTimeArea'>
        <div className='TeamsTimeDateText'>{moment(MatchData.start_Time).format("DD/MM/YY kk:mm")}</div>
        <div className='TeamsTimeStatText'><img alt='' src='/saha.png' width={25}></img><div className='TeamsDateAltText'>{MatchData.Venue_Name === 0 ? "-" : MatchData.venue_Name}</div></div>
        <div className='RefereeArea'><img alt='' width={19} height={19} src='/football-referee.png'></img><div className='RefereeTextStyle'>{MatchData.referees_Name}</div></div>
        <div className='TeamsInfoStaticScore'><div id={MatchData.home_Team_Id === MatchData.winner_Id ?'TeamsInfoStaticWin' :""} className='TeamsInfoStaticDiv'>{MatchData.home_Score}</div><span>-</span><div className='TeamsInfoStaticDiv' id={MatchData.away_Team_Id === MatchData.winner_Id ?'TeamsInfoStaticWin' :""}>{MatchData.away_Score}</div></div>
    </div>
    <div className='AwayTeamArea'>
       {/* <div className="container__inner">
           <div className="football-kit football-kit--hoops">
             <div className="football-kit__shirt"></div>
             <div className="football-kit__sleeve football-kit__sleeve--left"></div>
             <div className="football-kit__sleeve football-kit__sleeve--right"></div>
            </div>
        </div> */}
           <div className="container__inner">

            {
            Awayersey !== null ? 
              <div className="football-kit football-kit--stripes-away">
              <div style={{background: `repeating-linear-gradient(to right, ${Awayersey.primary}, ${Awayersey.primary} 10px, ${Awayersey.secondary} 10px, ${Awayersey.secondary} 17.5px) `}} className="football-kit__shirt"></div>
                <div style={{ background: 	`repeating-linear-gradient(to bottom, ${Awayersey.primary}, ${Awayersey.primary} 10px, ${Awayersey.secondary} 10px, ${Awayersey.secondary} 20px) `}} className="football-kit__stripes football-kit__stripes--left"></div>
                <div style={{background: ` repeating-linear-gradient(to bottom, ${Awayersey.primary}, ${Awayersey.primary} 10px, ${Awayersey.secondary} 10px, ${Awayersey.secondary} 20px)` }} className="football-kit__stripes football-kit__stripes--right"></div>
             </div>
             :
                   <div className="football-kit football-kit--stripes-away">
                   <div  className="football-kit__shirt"></div>
                     <div  className="football-kit__stripes football-kit__stripes--left"></div>
                     <div className="football-kit__stripes football-kit__stripes--right"></div>
            </div>
            }
   
        </div>
        <ToastContainer />
        <div className='TeamContainerTextHome'><img alt='' src={`https://cdn-images.nvpark.com/logo/${MatchData.away_Team_Id}.png` }  onError={addDefaultSrc} className='TeamsInfoImage'></img><div className='TeamContainerTeamName'>{MatchData.away_Team_Name}</div></div>
        {
                 MatchData.awayTeamManager !== null ?
                 <div className='ManagerPosition'>
                   <img src='/manager.png' width={17} height={17}></img>
                   <div className='ManagerText'>{MatchData.awayTeamManager}</div>
                </div>  
                :
                ""
             }
    </div>
</div>
</div>
  )
}
